/* RagingMoto storefront JS — vanilla, no dependencies.
   Every component is initialised idempotently per root and re-initialised on
   Shopify theme-editor section reloads (shopify:section:load). */
(function () {
  'use strict';

  var R = window.rmRoutes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', product: '/' };
  var isMobile = function () { return window.matchMedia('(max-width: 759px)').matches; };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    format = format || window.rmMoneyFormat || '${{amount}}';
    cents = parseInt(cents || 0, 10);
    function d(n, p, t, s) {
      t = t || ','; s = s || '.';
      var parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? s + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/); var key = m ? m[1] : 'amount'; var v;
    switch (key) {
      case 'amount_no_decimals': v = d(cents, 0); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = d(cents, 2, ' ', ','); break;
      default: v = d(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- smooth scroll / anchors ---------- */
  function scrollToId(id) {
    var el = id === 'top' ? document.body : document.getElementById(id);
    if (!el) return false;
    var top = id === 'top' ? 0 : el.getBoundingClientRect().top + window.scrollY - 64;
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-rm-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    if (i < 0) return;
    var path = href.slice(0, i); var id = href.slice(i + 1);
    if (path && path !== location.pathname) return; // different page: let browser navigate
    e.preventDefault();
    closeMenus(); Cart.close();
    if (!scrollToId(id || 'top')) {
      // anchor not on this page (cart / policy pages) → go to the product page section
      location.href = R.product + (id && id !== 'top' ? '#' + id : '');
    }
  });
  if (location.hash && location.hash.length > 1) {
    window.addEventListener('load', function () { setTimeout(function () { scrollToId(location.hash.slice(1)); }, 60); });
  }

  /* ---------- header menu ---------- */
  function closeMenus() {
    document.querySelectorAll('[data-rm-menu].is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.querySelectorAll('[data-rm-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rm-menu-toggle]');
    if (!t) return;
    var menu = document.getElementById(t.getAttribute('aria-controls'));
    if (!menu) return;
    var open = !menu.classList.contains('is-open');
    menu.classList.toggle('is-open', open);
    t.setAttribute('aria-expanded', String(open));
    if (open) Cart.close();
  });

  /* ---------- timer ---------- */
  function initTimer(root) {
    root.querySelectorAll('[data-rm-timer]').forEach(function (el) {
      if (el._rm) clearInterval(el._rm);
      var mode = el.dataset.mode, hours = parseFloat(el.dataset.hours || '12'), key = el.dataset.key;
      var end;
      function evergreen() {
        var stored = 0;
        try { stored = parseInt(localStorage.getItem(key) || '0', 10); } catch (x) {}
        if (!stored || stored < Date.now()) {
          stored = Date.now() + hours * 3600000;
          try { localStorage.setItem(key, String(stored)); } catch (x) {}
        }
        return stored;
      }
      if (mode === 'fixed' && el.dataset.end) { end = Date.parse(el.dataset.end); if (isNaN(end)) end = evergreen(); }
      else end = evergreen();
      var H = el.querySelector('[data-h]'), M = el.querySelector('[data-m]'), S = el.querySelector('[data-s]');
      var pad = function (n) { return String(n).padStart(2, '0'); };
      function tick() {
        var left = Math.max(0, end - Date.now());
        if (left === 0 && mode !== 'fixed') { try { localStorage.removeItem(key); } catch (x) {} end = evergreen(); left = end - Date.now(); }
        H.textContent = pad(Math.floor(left / 3600000)); M.textContent = pad(Math.floor(left / 60000) % 60); S.textContent = pad(Math.floor(left / 1000) % 60);
      }
      tick(); el._rm = setInterval(tick, 1000);
    });
  }

  /* ---------- cart ---------- */
  var Cart = {
    el: function () { return document.querySelector('[data-rm-drawer]'); },
    open: function (justAdded) {
      var d = this.el();
      if (!d) { location.href = R.cart; return; }
      closeMenus();
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rm-lock');
      var added = d.querySelector('[data-rm-added]'); if (added) added.hidden = !justAdded;
      var panel = d.querySelector('.rm-drawer__panel'); if (panel) panel.focus({ preventScroll: true });
      Sticky.update();
    },
    close: function () {
      var d = this.el(); if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rm-lock');
      Sticky.update();
    },
    isOpen: function () { var d = this.el(); return !!(d && d.classList.contains('is-open')); },
    fetch: function () {
      return window.__rmFetch(R.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
    },
    refresh: function (openAfter, justAdded) {
      var self = this;
      return this.fetch().then(function (cart) { self.render(cart); if (openAfter) self.open(justAdded); return cart; });
    },
    change: function (key, qty) {
      var d = this.el(); var body = d && d.querySelector('[data-rm-cart-body]');
      if (body) body.classList.add('rm-busy');
      var self = this;
      return window.__rmFetch(R.cartChange + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        if (body) body.classList.remove('rm-busy');
        if (cart && cart.items) self.render(cart); else self.refresh();
      }).catch(function () { if (body) body.classList.remove('rm-busy'); });
    },
    render: function (cart) {
      document.querySelectorAll('[data-rm-cart-count]').forEach(function (b) { b.textContent = cart.item_count; b.hidden = cart.item_count === 0; });
      var d = this.el(); if (!d) return;
      d.querySelectorAll('[data-rm-cart-count-plain]').forEach(function (b) { b.textContent = cart.item_count; });
      var body = d.querySelector('[data-rm-cart-body]'); var foot = d.querySelector('[data-rm-cart-foot]');
      var ds = d.dataset;
      if (!cart.items.length) {
        body.innerHTML = '<div class="rm-drawer__empty"><span>' + esc(ds.empty) + '</span><a href="#shop" data-rm-scroll data-rm-cart-close class="rm-btn-outline">' + esc(ds.continue) + '</a></div>';
        foot.hidden = true; return;
      }
      var html = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') + '" alt="' + esc(it.product_title) + '" loading="lazy" width="84" height="84">' : esc(ds.noimg);
        var meta = '';
        if (!it.product_has_only_default_variant && it.variant_title) meta += '<div class="rm-line__meta">' + esc(it.variant_title) + '</div>';
        if (it.properties) Object.keys(it.properties).forEach(function (k) { var v = it.properties[k]; if (k.charAt(0) !== '_' && v) meta += '<div class="rm-line__meta">' + esc(k) + ': ' + esc(v) + '</div>'; });
        if (it.line_level_discount_allocations) it.line_level_discount_allocations.forEach(function (a) { meta += '<div class="rm-line__meta" style="color:#0A7C3E">' + esc(a.discount_application.title) + ' (−' + formatMoney(a.amount) + ')</div>'; });
        if (it.selling_plan_allocation) meta += '<div class="rm-line__meta">' + esc(it.selling_plan_allocation.selling_plan.name) + '</div>';
        var was = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
        return '<div class="rm-line" data-key="' + esc(it.key) + '">' +
          '<a class="rm-line__img" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="rm-line__main"><div class="rm-line__top"><div><a class="rm-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + meta + '</div>' +
          '<span class="rm-line__price">' + formatMoney(it.final_line_price) + was + '</span></div>' +
          '<div class="rm-line__ctrls"><div class="rm-stepper">' +
          '<button type="button" data-rm-line-qty="' + (it.quantity - 1) + '" aria-label="Decrease">−</button>' +
          '<span style="width:32px;text-align:center;font-weight:700">' + it.quantity + '</span>' +
          '<button type="button" data-rm-line-qty="' + (it.quantity + 1) + '" aria-label="Increase">+</button></div>' +
          '<button type="button" class="rm-line__remove" data-rm-line-qty="0">' + esc(ds.remove) + '</button></div></div></div>';
      }).join('');
      body.innerHTML = html;
      foot.hidden = false;
      var disc = foot.querySelector('[data-rm-cart-discounts]');
      if (disc) {
        var apps = (cart.cart_level_discount_applications || []);
        disc.hidden = !apps.length;
        disc.innerHTML = apps.map(function (a) { return '<span>' + esc(a.title) + '</span><span>−' + formatMoney(a.total_allocated_amount) + '</span>'; }).join('');
      }
      foot.querySelector('[data-rm-cart-total]').textContent = formatMoney(cart.total_price);
    }
  };
  window.RMCart = Cart;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-rm-cart-open]')) { e.preventDefault(); Cart.open(false); Cart.refresh(); return; }
    if (e.target.closest('[data-rm-cart-close]')) { if (!e.target.closest('[data-rm-scroll]')) e.preventDefault(); Cart.close(); return; }
    var q = e.target.closest('[data-rm-line-qty]');
    if (q) { var line = q.closest('[data-key]'); Cart.change(line.dataset.key, Math.max(0, parseInt(q.dataset.rmLineQty, 10))); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { Cart.close(); closeMenus(); } });

  /* Watch cart requests made by apps (e.g. Kaching Bundles) so the drawer & badge always stay in sync. */
  var nativeFetch = window.fetch.bind(window);
  window.__rmFetch = nativeFetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.then(function (r) {
        if (!r.ok) return;
        var added = /\/cart\/add/.test(url);
        setTimeout(function () { Cart.refresh(added, added); }, 60);
      }).catch(function () {});
    }
    return p;
  };

  /* ---------- product ---------- */
  function initProduct(root) {
    root.querySelectorAll('[data-rm-product]').forEach(function (sec) {
      if (sec._rmInit) return; sec._rmInit = true;
      var data = {}; try { data = JSON.parse(sec.querySelector('[data-rm-product-json]').textContent); } catch (x) {}
      var form = sec.querySelector('[data-rm-form]');
      var idInput = form && form.querySelector('[data-rm-variant-id]');
      var atc = sec.querySelector('[data-rm-atc]');
      var err = sec.querySelector('[data-rm-error]');
      var track = sec.querySelector('[data-rm-track]');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-rm-slide]')) : [];
      var labelEl = sec.querySelector('[data-rm-slide-label]');
      var countEl = sec.querySelector('[data-rm-slide-count]');
      var current = 0, adding = false;

      /* gallery */
      function setActive(i) {
        current = i;
        var s = slides[i];
        if (labelEl && s) { var l = s.dataset.label || s.dataset.fallback || ''; labelEl.textContent = l; labelEl.style.display = l ? '' : 'none'; }
        if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
        sec.querySelectorAll('[data-rm-go]').forEach(function (b) { b.classList.toggle('is-active', parseInt(b.dataset.rmGo, 10) === i); });
        slides.forEach(function (sl, k) { if (k !== i) { var v = sl.querySelector('video'); if (v && !v.paused) { v.pause(); sl.classList.remove('is-playing'); } } });
      }
      function go(i) { if (!track) return; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setActive(i); }
      if (track) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current && i >= 0 && i < slides.length) setActive(i);
        }, { passive: true });
        setActive(0);
        track.addEventListener('click', function (e) {
          var sl = e.target.closest('.rm-slide--video'); if (!sl) return;
          var v = sl.querySelector('video'); if (!v) return;
          if (v.paused) { v.muted = false; v.controls = true; v.play(); sl.classList.add('is-playing'); } 
        });
      }
      sec.addEventListener('click', function (e) { var b = e.target.closest('[data-rm-go]'); if (b) go(parseInt(b.dataset.rmGo, 10)); });

      /* variants */
      function selectedOptions() {
        var opts = [];
        sec.querySelectorAll('[data-rm-option]:checked').forEach(function (i) { opts[parseInt(i.dataset.rmOption, 10)] = i.value; });
        return opts;
      }
      function currentVariant() {
        var id = idInput ? parseInt(idInput.value, 10) : 0;
        return (data.variants || []).filter(function (v) { return v.id === id; })[0] || (data.variants || [])[0];
      }
      function qty() {
        var q = form ? (form.querySelector('[name="quantity"]') || document.querySelector('[form="' + form.id + '"][name="quantity"]')) : null;
        var n = q ? parseInt(q.value, 10) : 1; return isNaN(n) || n < 1 ? 1 : n;
      }
      var lastSig = '';
      function updateUI(force) {
        var v = currentVariant(); if (!v) return;
        var q = qty();
        var sig = v.id + ':' + q + ':' + adding;
        if (!force && sig === lastSig) return; lastSig = sig;
        var price = formatMoney(v.price), onSale = v.compare_at_price > v.price;
        var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        document.querySelectorAll('[data-rm-price]').forEach(function (e) { e.textContent = price; });
        document.querySelectorAll('[data-rm-compare]').forEach(function (e) { e.hidden = !onSale; if (onSale) e.textContent = formatMoney(v.compare_at_price); });
        document.querySelectorAll('[data-rm-save]').forEach(function (e) { e.hidden = !onSale; e.textContent = (e.dataset.template || 'SAVE [percent]%').replace('[percent]', pct); });
        var total = formatMoney(v.price * q);
        if (atc) {
          atc.disabled = !v.available || adding;
          atc.textContent = adding ? atc.dataset.adding : (v.available ? atc.dataset.label.replace('[price]', total) : atc.dataset.soldout);
        }
        document.querySelectorAll('[data-rm-live-label]').forEach(function (b) {
          b.disabled = !v.available || adding;
          b.textContent = adding ? (atc ? atc.dataset.adding : 'ADDING…') : (v.available ? b.dataset.rmLiveLabel.replace('[price]', price) : (atc ? atc.dataset.soldout : 'SOLD OUT'));
        });
        document.querySelectorAll('[data-rm-sticky-btn]').forEach(function (b) {
          b.disabled = !v.available || adding;
          b.textContent = adding ? (atc ? atc.dataset.adding : 'ADDING…') : (v.available ? b.dataset.label : (atc ? atc.dataset.soldout : 'SOLD OUT'));
        });
        sec.querySelectorAll('[data-rm-lowstock]').forEach(function (ls) {
          if (ls.dataset.mode === 'inventory') {
            var show = v.inventory != null && v.inventory > 0 && v.inventory <= parseInt(ls.dataset.threshold, 10);
            ls.hidden = !show; ls.style.display = show ? '' : 'none';
          }
          var t = ls.querySelector('[data-rm-lowstock-text]'); if (t) t.textContent = t.dataset.template.replace('[count]', v.inventory == null ? '' : v.inventory);
        });
      }
      sec.addEventListener('change', function (e) {
        if (e.target.matches('[data-rm-option]')) {
          var opts = selectedOptions();
          var match = (data.variants || []).filter(function (v) { return v.options.every(function (o, i) { return opts[i] === o; }); })[0];
          if (match && idInput) {
            idInput.value = match.id;
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
            if (match.featured_media) {
              var idx = slides.findIndex(function (s) { return s.dataset.mediaId == match.featured_media; });
              if (idx > -1) go(idx);
            }
            if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', match.id); history.replaceState({}, '', u.toString()); }
          }
          if (atc && !match) { atc.disabled = true; }
        }
        updateUI(true);
      });
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('[data-rm-qty]'); if (b) {
          var inp = sec.querySelector('[data-rm-qty-input]');
          if (inp) { inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.rmQty, 10)); inp.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        requestAnimationFrame(function () { updateUI(); });
      });
      // bundle apps change the quantity / variant inputs programmatically: poll cheaply for changes
      sec._rmPoll = setInterval(function () { if (document.body.contains(sec)) updateUI(); else clearInterval(sec._rmPoll); }, 400);
      updateUI(true);

      function showError(msg) { if (!err) return; err.textContent = msg || ''; err.hidden = !msg; }

      /* add to cart — handled on document so apps that intercept the form (and call preventDefault) win */
      if (form) {
        form._rmSubmit = function () {
          if (adding) return;
          showError('');
          adding = true; updateUI(true);
          var fd = new FormData(form);
          if (!fd.get('quantity')) fd.set('quantity', String(qty()));
          window.__rmFetch(R.cartAdd + '.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              adding = false; updateUI(true);
              if (!res.ok) { showError(res.j.description || res.j.message || 'Could not add to cart.'); return; }
              Cart.refresh(true, true);
            })
            .catch(function () { adding = false; updateUI(true); form.submit(); });
        };
      }

      /* sticky mobile bar */
      if (atc && sec.dataset.sticky === 'true' && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var e = entries[0];
          Sticky.ctaHidden = !e.isIntersecting && e.boundingClientRect.top < 0;
          Sticky.update();
        });
        io.observe(atc); sec._rmIO = io;
      }
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-rm-form]')) return;
    if (e.defaultPrevented) return; // an app (e.g. bundle widget) already handled it
    e.preventDefault();
    form._rmSubmit && form._rmSubmit();
  });
  // Secondary CTAs (sticky bar, offer box, video button) submit the main product form so
  // the current variant / quantity / bundle selection is always respected.
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rm-submit],[data-rm-submit-main]');
    if (!b) return;
    var form = b.dataset.rmSubmit ? document.getElementById(b.dataset.rmSubmit) : document.querySelector('[data-rm-form]');
    if (!form) { location.href = R.product; return; }
    e.preventDefault();
    var btn = form.querySelector('[type="submit"][name="add"]');
    if (form.requestSubmit) form.requestSubmit(btn || undefined); else if (btn) btn.click();
  });

  var Sticky = {
    ctaHidden: false,
    update: function () {
      var bar = document.querySelector('[data-rm-sticky]'); if (!bar) return;
      var show = this.ctaHidden && isMobile() && !Cart.isOpen();
      bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', String(!show));
      document.body.classList.toggle('rm-has-sticky', show);
    }
  };
  window.addEventListener('resize', function () { Sticky.update(); });

  /* ---------- video ---------- */
  function initVideo(root) {
    root.querySelectorAll('[data-rm-video]').forEach(function (f) {
      if (f._rmInit) return; f._rmInit = true;
      var v = f.querySelector('video');
      var tpl = f.querySelector('template[data-rm-video-embed]');
      var prog = f.querySelector('[data-rm-video-prog] span');
      var muteBtn = f.querySelector('[data-rm-video-mute]');
      function label() { if (muteBtn && v) muteBtn.textContent = v.muted ? 'Unmute' : 'Mute'; }
      f.querySelector('[data-rm-video-play]').addEventListener('click', function () {
        if (v) { v.play(); f.classList.add('is-playing'); label(); }
        else if (tpl) { f.appendChild(tpl.content.cloneNode(true)); var p = f.querySelector('[data-rm-video-poster]'); if (p) p.remove(); this.remove(); }
      });
      if (!v) { if (muteBtn) muteBtn.closest('.rm-video__bar').remove(); return; }
      v.removeAttribute('controls');
      f.querySelector('[data-rm-video-pause]').addEventListener('click', function () { v.pause(); f.classList.remove('is-playing'); });
      if (muteBtn) muteBtn.addEventListener('click', function () { v.muted = !v.muted; label(); });
      v.addEventListener('timeupdate', function () { if (prog && v.duration) prog.style.width = (v.currentTime / v.duration * 100) + '%'; });
      v.addEventListener('ended', function () { f.classList.remove('is-playing'); });
      var bar = f.querySelector('[data-rm-video-prog]');
      if (bar) bar.addEventListener('click', function (e) { var r = bar.getBoundingClientRect(); if (v.duration) v.currentTime = (e.clientX - r.left) / r.width * v.duration; });
      label();
    });
  }

  /* ---------- tabs (gestures) ---------- */
  function selectTab(sec, i) {
    sec.querySelectorAll('[data-rm-tab]').forEach(function (t) { t.setAttribute('aria-selected', String(parseInt(t.dataset.rmTab, 10) === i)); });
    sec.querySelectorAll('[data-rm-panel]').forEach(function (p) { p.hidden = parseInt(p.dataset.rmPanel, 10) !== i; });
  }
  function initTabs(root) {
    root.querySelectorAll('[data-rm-tabs]').forEach(function (sec) {
      if (sec._rmInit) return; sec._rmInit = true;
      sec.addEventListener('click', function (e) { var t = e.target.closest('[data-rm-tab]'); if (t) selectTab(sec, parseInt(t.dataset.rmTab, 10)); });
      sec.addEventListener('keydown', function (e) {
        var t = e.target.closest('[data-rm-tab]'); if (!t) return;
        var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-rm-tab]')); var i = tabs.indexOf(t);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; tabs[n].focus(); selectTab(sec, n); }
      });
    });
  }

  /* ---------- FAQ ---------- */
  function setFaq(item, open) {
    item.classList.toggle('is-open', open);
    var q = item.querySelector('[data-rm-faq-q]'); q.setAttribute('aria-expanded', String(open));
    q.querySelector('.rm-faq__icon').textContent = open ? '−' : '+';
    item.querySelector('.rm-faq__a').hidden = !open;
  }
  function initFaq(root) {
    root.querySelectorAll('[data-rm-faq]').forEach(function (sec) {
      if (sec._rmInit) return; sec._rmInit = true;
      sec.addEventListener('click', function (e) {
        var q = e.target.closest('[data-rm-faq-q]'); if (!q) return;
        var item = q.closest('[data-rm-faq-item]'); var open = !item.classList.contains('is-open');
        if (sec.dataset.single === 'true') sec.querySelectorAll('[data-rm-faq-item].is-open').forEach(function (o) { if (o !== item) setFaq(o, false); });
        setFaq(item, open);
      });
    });
  }

  function init(root) {
    root = root || document;
    initTimer(root); initProduct(root); initVideo(root); initTabs(root); initFaq(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); Sticky.update(); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-rm-timer]').forEach(function (t) { clearInterval(t._rm); });
    e.target.querySelectorAll('[data-rm-product]').forEach(function (s) { clearInterval(s._rmPoll); if (s._rmIO) s._rmIO.disconnect(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    var tab = b.closest && b.closest('[data-rm-tab]');
    if (tab) selectTab(tab.closest('[data-rm-tabs]'), parseInt(tab.dataset.rmTab, 10));
    var faq = b.closest && b.closest('[data-rm-faq-item]');
    if (faq) setFaq(faq, true);
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-rm-drawer]')) { Cart.open(false); Cart.refresh(); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.querySelector('[data-rm-drawer]')) Cart.close();
  });
})();
